import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import { DatePicker, DatePickerValue } from '../../../../components/date-picker';

const weekdayOptions = [
  { label: 'Man', value: 1 },
  { label: 'Tir', value: 2 },
  { label: 'Ons', value: 3 },
  { label: 'Tor', value: 4 },
  { label: 'Fre', value: 5 },
];

interface ICitizenLessonDeviationWeekdaySelectorProps {
  onApply: (weekdays: number[], fromDate: DatePickerValue, toDate: DatePickerValue) => void;
}

export function CitizenLessonDeviationWeekdaySelector(props: ICitizenLessonDeviationWeekdaySelectorProps) {
  const { onApply } = props;
  const [selectedWeekdays, setSelectedWeekdays] = useState<number[]>([]);
  const [fromDate, setFromDate] = useState<DatePickerValue>(undefined);
  const [toDate, setToDate] = useState<DatePickerValue>(undefined);

  function handleWeekdayToggle(weekday: number) {
    setSelectedWeekdays(current => (current.includes(weekday) ? current.filter(day => day !== weekday) : [...current, weekday]));
  }

  function handleApplyClick() {
    onApply(selectedWeekdays, fromDate, toDate);
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, minWidth: 340 }}>
      <FormControl component="fieldset">
        <FormLabel component="legend">Ugedage</FormLabel>
        <FormGroup row sx={{ '& .MuiCheckbox-root': { paddingRight: 0.5 } }}>
          {weekdayOptions.map(option => (
            <FormControlLabel
              key={option.value}
              control={<Checkbox checked={selectedWeekdays.includes(option.value)} onChange={() => handleWeekdayToggle(option.value)} />}
              label={option.label}
            />
          ))}
        </FormGroup>
      </FormControl>
      <FormControl component="fieldset">
        <FormLabel component="legend" sx={{ mb: 1 }}>
          Periode
        </FormLabel>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <DatePicker label="Fra" value={fromDate} onChange={setFromDate} variant="outlined" fullWidth />
          <DatePicker label="Til" value={toDate} onChange={setToDate} variant="outlined" fullWidth />
        </Box>
      </FormControl>
      <Button variant="contained" onClick={handleApplyClick} sx={{ alignSelf: 'flex-end' }}>
        Anvend
      </Button>
    </Box>
  );
}
